export function formatCurrency(value, withCurrencyName = false, decimalDigits = 0) {
    if (withCurrencyName) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: decimalDigits,
        maximumFractionDigits: decimalDigits,
      }).format(value);
    } else {
      return new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: decimalDigits,
        maximumFractionDigits: decimalDigits,
      }).format(value);
    }
  }